import "./StatCard.css";

/*
  StatCard Component

  A number with a label (summary / KPI). Pass `onClick` ONLY when clicking
  really does something (e.g. applies the matching filter): then it is a button
  with aria-pressed; otherwise it is a plain, non-interactive block.

  label    text under the number
  value    the number (or "—" while unknown)
  active   this card's filter is currently applied
  onClick  optional
  loading  value is being refreshed
*/

const StatCard = ({ label, value, active = false, onClick, loading = false, className = "" }) => {
  const body = (
    <>
      <span className="ui-stat-value" aria-busy={loading || undefined}>{value}</span>
      <span className="ui-stat-label">{label}</span>
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={`ui-stat-card interactive ${active ? "active" : ""} ${className}`} aria-pressed={active} onClick={onClick}>
        {body}
      </button>
    );
  }
  return <div className={`ui-stat-card ${active ? "active" : ""} ${className}`}>{body}</div>;
};

export default StatCard;
